<div class="drawer-overlay" *ngIf="visible" (click)="close()"></div>
<div *ngIf="visible" class="drawer" [ngClass]="{ 'show': visible }" [class]="customClass">
  <div class="drawer-content">
    <div *ngIf="showCloseButton" class="row">
      <button class="close-btn cursor" (click)="close()">X</button>
    </div>

    <ng-content></ng-content>

  </div>
</div>